import { Link } from "react-router-dom";
import { LandingHeader, LandingFooter } from "@/components/landing";

interface LegalPageLayoutProps {
  title: string;
  subtitle: string;
  children: React.ReactNode;
}

export function LegalPageLayout({ title, subtitle, children }: LegalPageLayoutProps) {
  return (
    <div className="min-h-screen bg-[#0F172A] flex flex-col">
      <LandingHeader />

      {/* Hero */}
      <section className="pt-32 pb-12 text-center">
        <div className="max-w-4xl mx-auto px-4">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white">
            {title}
          </h1>
          <p className="mt-4 text-base md:text-lg text-white/60">
            {subtitle}
          </p>
        </div>
      </section>

      {/* Contenu */}
      <section className="flex-1 max-w-3xl mx-auto px-4 pb-20 w-full">
        <div className="prose prose-invert prose-gray max-w-none
          prose-headings:text-[#F59E0B] prose-headings:font-semibold
          prose-h2:text-xl prose-h2:md:text-2xl prose-h2:mt-10 prose-h2:mb-4
          prose-h3:text-base prose-h3:md:text-lg prose-h3:text-white prose-h3:mt-6
          prose-p:text-white/60 prose-p:leading-relaxed prose-p:text-sm prose-p:md:text-base
          prose-li:text-white/60 prose-li:text-sm prose-li:md:text-base
          prose-a:text-[#F59E0B] prose-a:no-underline hover:prose-a:underline
          prose-strong:text-white
          prose-table:text-white/60
          prose-th:text-white prose-th:bg-[#1E293B] prose-th:px-4 prose-th:py-2 prose-th:text-sm
          prose-td:px-4 prose-td:py-2 prose-td:border-[#374151] prose-td:text-sm
        ">
          {children}
        </div>
      </section>

      <LandingFooter />
    </div>
  );
}
